import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MasterYourMoneyMasterYourLife from "./sections/MasterYourMoneyMasterYourLife";
import DeveloperEcosystem from "./sections/DeveloperEcosystem";
import AreasOfExpertise from "./sections/AreasOfExpertise";
import ByTheNumbers from "./sections/ByTheNumbers";
import SicherheitVertrauen from "./sections/SicherheitVertrauen";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import FooterInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <MasterYourMoneyMasterYourLife />
      <DeveloperEcosystem />
      <AreasOfExpertise />
      <ByTheNumbers />
      <SicherheitVertrauen />
      <CustomerTestimonials />
      <FooterInfo />
    </div>;
}